import { QueryTarget } from "@/shared/domain/query";

/**
 * The tables a View can be saved from. Each one has a filter picker and is
 * also its list page's path. Order is presentation order wherever the six are
 * listed.
 *
 * Lives in the domain rather than beside the filter catalog, because the
 * chat's View tools have to know the set too — and a domain module importing
 * a constant out of a component tree inverts the layering.
 */
export const VIEW_TARGETS = [
  QueryTarget.Datasets,
  QueryTarget.Files,
  QueryTarget.Events,
  QueryTarget.Sessions,
  QueryTarget.Devices,
  QueryTarget.Collections,
] as const;

export type ViewTarget = (typeof VIEW_TARGETS)[number];
